export var MEDIA_COUNT_FEATURE = 'MEDIA_COUNT_FEATURE';
export var mediaCountFeature = function (editorState, raw) {
    var emotes = 0;
    var emoji = 0;
    var images = 0;
    var mentions = 0;
    var video = 0;
    var previews = 0;
    for (var key in raw.entityMap) {
        var entity = raw.entityMap[key];
        switch (entity.type) {
            case 'EMOJI_TYPE':
                emoji++;
                break;
            case 'DA_COMM_EMOTE':
            case 'DA_OFF_EMOTE':
                emotes++;
                break;
            case 'wix-draft-plugin-gallery':
                if (entity.data && entity.data.data) {
                    images += entity.data.data.length;
                }
                break;
            case 'wix-draft-plugin-image':
                if (entity.data && entity.data.data) {
                    images++;
                }
                break;
            case 'wix-draft-plugin-giphy':
                if (entity.data) {
                    images++;
                }
                break;
            case 'mention':
                mentions++;
                break;
            case 'wix-draft-plugin-video':
                if (entity.data && entity.data.src) {
                    video++;
                }
                break;
            case 'wix-draft-plugin-link-preview':
                if (entity.data) {
                    previews++;
                }
                break;
            default:
        }
    }
    return {
        type: MEDIA_COUNT_FEATURE,
        data: {
            emoji: emoji,
            emotes: emotes,
            images: images,
            mentions: mentions,
            video: video,
            previews: previews,
        },
    };
};
//# sourceMappingURL=mediaCount.js.map